export default __webpack_public_path__ + "media/NotFound.743b732d0352fc6a2b0b4d291a13c6f2.svg";